import { render, staticRenderFns } from "./soc-canvas.vue?vue&type=template&id=7ffd8aee&"
import script from "./soc-canvas.vue?vue&type=script&lang=js&"
export * from "./soc-canvas.vue?vue&type=script&lang=js&"
import style0 from "./soc-canvas.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports